import { Component, OnInit } from '@angular/core';
import { ClockService } from './clock.service';

@Component({
    selector: 'cdp-clock',
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.scss'],
    standalone: false
})
export class ClockComponent implements OnInit {
    localTime = '';
    localTimeLong = '';
    utcTime = '';
    utcTimeLong = '';
    timeOffset = '';
    offsetTooltip = '';
    get showingClock(): boolean {
        return this.clockService.showingClock;
    }
    readonly _longDateTimeFormat: Intl.DateTimeFormatOptions = {
        weekday: 'short',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZoneName: 'short'
    };
    readonly shortTimeFormat: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
        timeZoneName: 'short'
    };

    constructor(public clockService: ClockService) {}

    ngOnInit(): void {
        this.updateTime();
        setInterval(() => this.updateTime(), 1000);
    }

    updateTime(): void {
        const now = new Date();
        const currentTimeZoneDesc = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const currentTimeZone = this.formatTime(now, { timeZoneName: 'short' }).split(' ').pop();

        // Get local time with specified formats
        this.localTimeLong = this.formatTime(now, this._longDateTimeFormat);
        this.localTime = this.formatTime(now, this.shortTimeFormat);

        // Get UTC time with specified format
        const utcDate = new Date(now.toISOString().split('.')[0] + 'Z');
        const utcLongTimeFormat = Object.assign({}, this._longDateTimeFormat, {
            timeZone: 'UTC',
            timeZoneName: undefined
        });
        const utcShortTimeFormat = Object.assign({}, this.shortTimeFormat, {
            timeZone: 'UTC',
            timeZoneName: undefined
        });
        this.utcTimeLong = this.formatTime(now, utcLongTimeFormat);
        this.utcTime = this.formatTime(utcDate, utcShortTimeFormat) + ' UTC';

        // Calculate time offset in hours
        const offsetMinutes = now.getTimezoneOffset();
        const offsetHours = Math.abs(offsetMinutes / 60);
        const offsetSign = offsetMinutes <= 0 ? '-' : '+';
        this.timeOffset = offsetHours > 0 ? `${offsetSign}${offsetHours} hrs` : '';
        this.offsetTooltip =
            offsetHours > 0
                ? `UTC time is ${offsetHours} hours ${offsetSign === '+' ? 'ahead of' : 'behind'} ${currentTimeZone} (${currentTimeZoneDesc})`
                : `UTC time is the same as ${currentTimeZone}`;
    }

    formatTime(date: Date, options: Intl.DateTimeFormatOptions): string {
        return new Intl.DateTimeFormat('en-US', options).format(date);
    }
}
